var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "loading_show"
        },
        [_c("div", { staticClass: "spinner-border text-danger" })]
      ),
      _vm._v(" "),
      _vm.updatePrimaryAdminMsg
        ? _c("div", { staticClass: "text-green" }, [
            _vm._v(_vm._s(_vm.updatePrimaryAdminMsg))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", [_vm._v(_vm._s(_vm.formatAddress(_vm.overview)))]),
          _vm._v(" "),
          _vm.overview.phone_number
            ? _c("div", [
                _c("i", { staticClass: "fa fa-phone overview-icons" }),
                _vm._v(
                  "   " +
                    _vm._s(
                      _vm._f("formatOverviewPhoneNumber")(
                        _vm.overview.phone_number
                      )
                    )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "overview-title" }, [
            _vm._v("Primary Manager   \n                "),
            !_vm.readOnly
              ? _c(
                  "a",
                  {
                    staticClass: "linkable",
                    on: {
                      click: function($event) {
                        return _vm.openUpdatePrimaryManagerModal(_vm.overview)
                      }
                    }
                  },
                  [_vm._v("Change")]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.overview.primary_email
          ? _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "mb-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.overview.primary_fname +
                      " " +
                      _vm.overview.primary_lname
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "mailto",
                    attrs: { href: "mailto:" + _vm.overview.primary_email }
                  },
                  [
                    _c("i", { staticClass: "fa fa-envelope-o overview-icons" }),
                    _vm._v("   " + _vm._s(_vm.overview.primary_email))
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.overview.primary_phone_number
                ? _c("div", { staticClass: "mt-1" }, [
                    _c("i", { staticClass: "fa fa-phone overview-icons" }),
                    _vm._v(
                      "   " +
                        _vm._s(
                          _vm._f("formatOverviewPhoneNumber")(
                            _vm.overview.primary_phone_number
                          )
                        )
                    )
                  ])
                : _vm._e()
            ])
          : _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "mb-1 text-red" }, [
                _vm._v("No Primary Admin Found")
              ])
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "license_panel_heading" }, [
            _c("div", { staticClass: "lheading_1 overview-title" }, [
              _vm._v("License")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lheading_2" }, [
              _c(
                "a",
                {
                  staticClass: "linkable",
                  on: { click: _vm.openAddSubscriptionModal }
                },
                [_vm._v("Add " + _vm._s(_vm.overview.subscriptionName))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", [
              _vm._v("\n                    Active License: "),
              _c("b", [_vm._v(_vm._s(_vm.overview.activeLicense))])
            ]),
            _vm._v("\n                    Used License: "),
            _c("b", [_vm._v(_vm._s(_vm.overview.usedLicense))]),
            _vm._v(" "),
            _c("div")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("UpdatePrimaryManagerModal", {
        ref: "update_primary_modal",
        attrs: {
          isUpdatePrimaryManagerModalVisible:
            _vm.isUpdatePrimaryManagerModalVisible,
          readOnly: _vm.readOnly
        },
        on: { close: _vm.closeUpdatePrimaryManagerModal }
      }),
      _vm._v(" "),
      _c("RenewAccountLicense", {
        ref: "renew_account_license",
        attrs: {
          isRenewModalVisible: _vm.isRenewModalVisible,
          accountId: _vm.accountId
        },
        on: { close: _vm.closeRenewModal }
      }),
      _vm._v(" "),
      _c("AddNewAccountLicense", {
        ref: "add_new_account_license",
        attrs: {
          isAddNewAccountLicenseModalVisible:
            _vm.isAddNewAccountLicenseModalVisible,
          accountId: _vm.accountId
        },
        on: { close: _vm.closeAddSubscriptionModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "overview-title" }, [_vm._v("Address")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01aa43c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01aa43c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/overview_tab.vue
// module id = null
// module chunks = 